import {Component} from "react"
import PropTypes from "prop-types"

import MenuItem from "../MenuItem/MenuItem.jsx"

import CardRow from "../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../shared/components/Styled/Card/CardCol.jsx"

import IconThreeDots from '../../../../shared/containers/Layout/icons/sidebar/icn-three-dots.svg'
import IconClose from '../../../../shared/containers/Layout/icons/sidebar/icn-close.svg'

import './MobileMenu.scss'

class MobileMenu extends Component {

  static propTypes = {
    items: PropTypes.object.isRequired,
    isCurrentRoute: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      isFullMenu: false
    }
  }

  onSetFullMenu = (isFullMenu) => {
    this.setState({isFullMenu: isFullMenu})
  }

  render() {
    const {items} = this.props
    const {isFullMenu} = this.state

    return (
      <div id="mobile-menu" className={`mobile-menu ${this.state.isFullMenu? 'mobile-menu-full': ''}`}>
        <div className="btn-wrapper">
          {Object.keys(items).map((itemKey, index) => {
            const item = items[itemKey]
            return <MenuItem
              key={`mobile-menu-item-${index}`}
              linkRoute={item.route}
              isCurrentRoute={this.props.isCurrentRoute(item.isCurrentRouteKey)}
              alt={item.alt}
              activeIcon={item.activeIcon}
              icon={item.icon}
              label={item.label}
              className={(item.showOnShortMobileMenu) ? '': 'hide-short-mobile-menu' }
              menuType={item.type}
              onClick={item.onClick}
            />
          } )}

          <div className="toggle-show-more">
            {isFullMenu
              ? <CardRow
                direction="column"
                align="center"
                onClick={() => {this.onSetFullMenu(false)}}>
                <CardCol className="label-col">
                  <img src={IconClose} alt="autre"/>
                </CardCol>
                <CardCol>
                  <span className="label">Fermer</span>
                </CardCol>
              </CardRow>
              : <CardRow
                direction="column"
                align="center"
                onClick={() => {this.onSetFullMenu(true)}}>
                <CardCol style={{height: '38px'}}>
                  <img src={IconThreeDots} alt="autre" />
                </CardCol>
                <CardCol className="label-col">
                  <span className="label">Autre</span>
                </CardCol>
              </CardRow>
            }
          </div>
        </div>

      </div>
    )
  }
}

export default MobileMenu
